import React, { useEffect, useRef } from "react";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

const pinIcon = L.divIcon({
  className: "bg-transparent",
  html: `<div style="width:32px;height:32px;border-radius:50% 50% 50% 0;background:#FF6B35;transform:rotate(-45deg);box-shadow:0 3px 8px rgba(0,0,0,.35);border:2px solid #fff;display:flex;align-items:center;justify-content:center">
    <div style="transform:rotate(45deg);color:#fff;font-size:14px">📍</div></div>`,
  iconSize: [32, 32],
  iconAnchor: [16, 30],
});

export const LocationPicker = ({ lat, lng, onChange }) => {
  const elRef = useRef(null);
  const mapRef = useRef(null);
  const markerRef = useRef(null);

  useEffect(() => {
    if (mapRef.current || !elRef.current) return;
    const m = L.map(elRef.current, { zoomControl: true, attributionControl: false }).setView([lat || 17.4, lng || 78.4], 16);
    L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", { maxZoom: 19 }).addTo(m);
    const mk = L.marker([lat || 17.4, lng || 78.4], { icon: pinIcon, draggable: true }).addTo(m);
    mk.on("dragend", () => { const p = mk.getLatLng(); onChange?.({ lat: p.lat, lng: p.lng }); });
    m.on("click", (e) => { mk.setLatLng(e.latlng); onChange?.({ lat: e.latlng.lat, lng: e.latlng.lng }); });
    mapRef.current = m; markerRef.current = mk;
    return () => { m.remove(); mapRef.current = null; markerRef.current = null; };
  }, []);

  useEffect(() => {
    if (mapRef.current && markerRef.current && lat && lng) {
      markerRef.current.setLatLng([lat, lng]);
      mapRef.current.setView([lat, lng], 16);
    }
  }, [lat, lng]);

  return <div ref={elRef} className="w-full h-[180px] rounded-xl overflow-hidden border border-border" data-testid="address-map-picker" />;
};
